export const CLOSE_SIDEPANEL_EVENT_NAME = 'closeSidepanelEvent'
